// src/services/microCreditService.js
import api from './api';

const BASE = '/microcredit';

export default {
  list: (params = {}) =>
    api.get(BASE, { params: { functionCode: 'MICRO_CREDIT_VIEW', ...params } }).then(r => r.data),

  get: (id) =>
    api.get(`${BASE}/${id}`, { params: { functionCode: 'MICRO_CREDIT_VIEW' } }).then(r => r.data),

  create: (data) =>
    api.post(BASE, { ...data, functionCode: 'MICRO_CREDIT_CREATE' }).then(r => r.data),

  update: (id, data) =>
    api.put(`${BASE}/${id}`, { ...data, functionCode: 'MICRO_CREDIT_UPDATE' }).then(r => r.data),

  remove: (id) =>
    api.delete(`${BASE}/${id}`, { data: { functionCode: 'MICRO_CREDIT_DELETE' } }).then(r => r.data),

  confirm: (id) =>
    api.post(`${BASE}/${id}/confirm`, { functionCode: 'MICRO_CREDIT_CONFIRM' }).then(r => r.data),

  notConfirm: (id) =>
    api.post(`${BASE}/${id}/not-confirm`, { functionCode: 'MICRO_CREDIT_CONFIRM' }).then(r => r.data),
};